module.exports = __webpack_public_path__ + "static/img/Ambientika+HAQCS.1b09c89.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/Ambientika+HAQCS.png
// module id = 49
// module chunks = 1 2